// 共用空狀態 — 給 list page 跟 detail panel 用, 文字統一 (S2 stress-audit 2026-05-10)。
//
// 兩種模式:
//   1. resource + isAdmin → 自動文案
//      <EmptyState resource="基金" isAdmin={isAdmin} />
//      admin: 「目前 tenant 還沒有任何基金。 點右上「+ 新增」開始建立。」
//      member: 「此使用者尚未被指派可看的基金 (RLS 過濾)。 請 admin 在「成員 →
//               資源指派矩陣」加上指派。」
//
//   2. 自訂訊息: <EmptyState>尚無估值記錄...</EmptyState>

interface ResourceModeProps {
  resource: string;
  isAdmin: boolean;
  /** 額外提示 (e.g. 「fund_manager 自動繼承...」) */
  hint?: string;
  children?: never;
}

interface CustomModeProps {
  resource?: never;
  isAdmin?: never;
  hint?: never;
  children: React.ReactNode;
}

type Props = ResourceModeProps | CustomModeProps;

export function EmptyState(props: Props) {
  // 2026-08-22 稽核: hint 原本**只接在非-admin 那一支**, admin 分支直接把它丟掉。
  // /lp-users 就是這樣: 它傳了「Investor 自行註冊後會出現在這裡；也可由管理員直接
  // 建立。」而且 isAdmin 寫死 true → 那句話從來沒有被渲染過。 作者寫了對的說明,
  // 元件把它吞了。 兩支都接上。
  const base =
    props.isAdmin === true
      ? `尚無${props.resource}。點右上「+ 新增」開始建立。`
      : `你尚未被指派可看的${props.resource}。請管理員在「叁石成員 → 資源指派矩陣」加上指派。`;
  const text =
    'children' in props && props.children !== undefined
      ? props.children
      : `${base}${props.hint ? ` ${props.hint}` : ''}`;

  return (
    <div className="bg-slate-50 border border-slate-200 rounded p-6 text-sm text-slate-500">
      {text}
    </div>
  );
}
